export function formatToURL(str) {
  if (!str) return "";
  return str
    .normalize("NFD")
    .replace(/\s+/g, "-")
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z-])/g, "")
    .replaceAll("---", "-")
    .toLocaleLowerCase();
}
